module.exports = __webpack_public_path__ + "media/images/sort_arrow_up-24f166b1003f0d30c0856fee7da6d962.png";